import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ExploreIcon from '@mui/icons-material/Explore';
import { AppContext } from '../window';
import { useTranslation } from '../i18n';

interface EmptyMatchesProps {
  onMatcherClick?: () => void;
}

export const EmptyMatches: React.FC<EmptyMatchesProps> = ({
  onMatcherClick
}) => {
  const { t } = useTranslation();
  const { texts } = useContext(AppContext);
  const navigate = useNavigate();

  const handleMatcherClick = () => {
    if (onMatcherClick) {
      onMatcherClick();
    } else {
      // Default behavior: navigate to matcher and set hash
      navigate('/match');
      window.location.hash = 'match';
    }
  };

  return (
    <div className="empty-matches d-flex justify-content-center align-items-center min-vh-50 mt-3">
      <Card className="text-center empty-state-card shadow-sm" style={{ maxWidth: '400px' }}>
        <Card.Body className="p-4">
          <div className="empty-icon mb-3">
            <FavoriteIcon style={{ fontSize: '4rem', color: '#6c757d' }} />
          </div>
          
          <Card.Title className="h4 mb-3">
            {t('user.no_matches_title')}
          </Card.Title>
          
          <Card.Text className="text-muted mb-4">
            {t('user.no_matches_message')}
          </Card.Text>

          <div className="d-grid gap-2">
            <Button 
              variant="primary" 
              size="lg" 
              onClick={handleMatcherClick}
              className="mb-2"
            >
              <ExploreIcon className="me-2" />
              {t('user.go_to_matcher')}
            </Button>
          </div>

          <div className="mt-4 text-muted small">
            <p className="mb-0">
              {t('user.matches_hint')}
            </p>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};